// 部分价格整数和小数部分字体大小不一样，所以使用这个方法
export default function (val) {
  if (isNaN(val)) return val
  val = val.toString()
  return `${val.slice(0, val.indexOf('.'))}.<span class="tofixedPrices">${val.slice(val.indexOf('.')+1)}</span>`
}


// WEBPACK FOOTER //
// ./resources/js/components/formPrice.js